import { axiosClient } from '@/lib/axios'

export const postSessionLogout = async (bodyParams) => {
  console.log('bodyParams', bodyParams)
  return axiosClient.post('/api/session/logout', bodyParams)
}